import { httpClient } from '@/services/http/httpClient'

export type UpdateTaskCommentProps = {
  id: string
  comment: string
  projectId: string
}

export async function updateTaskComment({
  id,
  comment,
  projectId,
}: UpdateTaskCommentProps) {
  await httpClient.put(`/projects/task-comments/${projectId}/${id}`, {
    comment,
  })
}
